import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Header.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import { Link, NavLink } from 'react-router-dom';
import Particles from '../../utils/particles';
const Header = () => {
  const path = useContext(PathContext);
  const stateApp = useContext(StateContext);
  const { updateStage, updateMenuOpen, menuOpen } = stateApp;
  const refBurger = useRef(null);
  const refMenu = useRef(null);
  const refBg1 = useRef(null);
  const refBg2 = useRef(null);
  const [isOpen, setOpen] = useState(false);
  let linkClassActive = `${styles.link}`;
  let linkClass = `${styles.link} ${styles.active}`;

  const openMenu = () => {
    const burger = refBurger.current;
    const menu = refMenu.current;
    const body = document.body;
    const root = document.querySelector('#root');
    if (!menuOpen) {
      burger.classList.add(styles.active);
      menu.classList.add(styles.active);
      body.style.overflow = 'hidden';
      root.style.overflow = 'hidden';
      updateMenuOpen(true);
      // updateTransition(true);
    } else {
      closeMenu();
    }
  }
  const closeMenu = (number = -1) => {
    const burger = refBurger.current;
    const menu = refMenu.current;
    const body = document.body;
    const root = document.querySelector('#root');
    updateMenuOpen(false);

    // updateTransition(false);
    burger.classList.remove(styles.active);
    menu.classList.remove(styles.active);
    body.style.overflow = '';
    root.style.overflow = '';
    if (number !== -1) {
      updateStage(number);
    }
  }

  let menu = <div className={styles.menu} ref={refMenu}>
    <div className={styles.menu__inner}>
    <div className={styles.list}>
      <div className={styles.item}>
        <Link to='../' className={styles.item__title} onClick={() => { closeMenu(0) }}>Путешествие груза</Link>
        <div className={styles.item__list}>
          <Link to='../' className={styles.item__link} onClick={() => { closeMenu(15) }}>Как мы работаем</Link>
          <Link to='../' className={styles.item__link} onClick={() => { closeMenu(17) }}>Что входит в ставку</Link>
          <Link to='../' className={styles.item__link} onClick={() => { closeMenu(18) }}>Что мы перевозим</Link>
          <Link to='../' className={styles.item__link} onClick={() => { closeMenu(23) }}>Почему выбирают нас</Link>
        </div>
        <div className={styles.item__bg} ref={refBg1}>
          <img src={`${path}/img/header-item-1.webp`} alt="" />
        </div>
      </div>
      <div className={styles.item}>
        <Link to='../compare' className={styles.item__title} onClick={() => { closeMenu(0) }}>Сравнение
модальностей</Link>
        <div className={styles.item__bg} ref={refBg2}>
          <img src={`${path}/img/header-item-2.webp`} alt="" />
          </div>
      </div>
      <div className={styles.item}>
        <Link to='../services' className={styles.item__title} onClick={() => { closeMenu(0) }}>Услуги</Link>
        <div className={styles.item__list}>
          <Link to='../services' className={styles.item__link} onClick={() => { closeMenu(1) }}>Транзитные перевозки</Link>
          <Link to='../services' className={styles.item__link} onClick={() => { closeMenu(7) }}>Перевозки из Китая</Link>
          <Link to='../services' className={styles.item__link} onClick={() => { closeMenu(13) }}>Перевозки в Китай</Link>
          
        </div>
        <div className={styles.item__qr}>
            <img src={`${path}/img/header-qr.webp`} alt="" />
          </div>
        <div className={styles.item__bg} ref={refBg2}>
          <img src={`${path}/img/header-item-3.webp`} alt="" />
          </div>
      </div>
    </div>
    <div className={styles.footer}>
      
    <a className={styles.infografika} href='https://www.infografika.agency/' target='_blank' rel='noreferrer'>
      <span>Сайт сделан в агентстве</span>
      <img src={`${path}/img/logo-infografika.svg`} alt="" />
    </a>
    <div className={styles.lang}>
          <a href={`${path}/`} className={`${styles.lang__link} ${styles.lang__link_disable}`}>RU</a>
          <a href={`${path}/en/index.html`} className={styles.lang__link}>EN</a>
          <a href={`${path}/cn/index.html`} className={styles.lang__link}>中文</a>
        </div>
    </div>
  </div>
  </div>;
  return (
    <>
      <header className={styles.wrap}>
        <div className={styles.burger} ref={refBurger} onClick={openMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={styles.logo}>
          <img src={`${path}/img/logo.svg`} alt="" />
        </div>
        {menu}
        <nav className={styles.nav}>
          <NavLink to='/' className={({ isActive }) => isActive ? linkClass : linkClassActive} onClick={() => { updateStage(0) }}>Путешествие груза</NavLink>
          <NavLink to='compare' className={({ isActive }) => isActive ? linkClass : linkClassActive } onClick={()=>{updateStage(0)}}>Сравнение модальностей</NavLink>
          <NavLink to='services' className={({ isActive }) => isActive ? linkClass : linkClassActive} onClick={() => { updateStage(0) }}>услуги</NavLink>
        </nav>
        <div className={styles.lang}>
          <a href={`${path}/`} className={`${styles.lang__link} ${styles.lang__link_disable}`}>RU</a>
          <a href={`${path}/en/index.html`} className={styles.lang__link}>EN</a>
          <a href={`${path}/cn/index.html`} className={styles.lang__link}>中文</a>
        </div>
      </header>
    </>
  );

}

export default Header;
